import { Link } from "react-router";
import fullLogo from "../navigation/full-logo.png";
import smallLogo from "../navigation/small-logo.png";

export default function Logo() {
  return (
    <Link to="/dashboard" className="flex px-2 lg:px-0">
      <div className="flex flex-shrink-0 items-center">
        <img
          alt="Park Road Concierge Logo"
          src={fullLogo}
          className="hidden lg:flex h-8 w-auto"
        />
        <img
          alt="Park Road Concierge Logo"
          src={smallLogo}
          className="lg:hidden h-8 w-auto"
        />
      </div>
    </Link>
  );
}
